module.exports = __webpack_public_path__ + "static/img/REGENERATIVE-AGRICULTURAL-PRACTICES-DESKTOP.8ef3176e.jpg";